import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { SelectorSimpleFactory } from "../logic";
const StatusCaja = (props: { value: models.StatusCajaRutaViewDto | null }) => {
    const x = props.value;
    if (x == null) return <span style={{ fontStyle: "italic", color: "red" }}  >Sin status</span>;
    const datos = 
        [ x.NombreSucursal, x.NombreViaje ? (x.NombreViajeSucursalOrigen + " - " + x.NombreViajeSucursalDestino) : undefined]
        .filter(x => x != null).join(", ");

    const ban = <i className={fa("ban")} />;
    const camion =
        <span>
            <i className={fa("truck")} />
            <span title="Camión conectadp" >{x.NombreCamionConectado || ban}</span>
            <i className={fa("toggle-down")} />
            <span title="Camión asignado" >{x.NombreCamionConectado || ban}</span>
        </span>;
    return (
        <div>
            <span style={{ fontStyle: "italic" }} > {datos}</span>,
            <br />
            {camion}
        </div>
    )
}

export class CajaRutaItem extends React.PureComponent<{ value: models.CajaRutaDTO }> {
    render() {
        const x = this.props.value;


        return (
            <div>
                {x.Nombre}
                <br />
                <StatusCaja value={x.UltimoStatus} />
            </div>
        )
    }
}

export const CajaRuta = SelectorSimpleFactory(observeResource(resources.CajaRuta.query), x => x.IdRegistro, x => ({
    label: x.Nombre,
    view: <CajaRutaItem value={x} />
}));



// WEBPACK FOOTER //
// ./app/features/selectores/items/cajaruta.tsx